/* ZTreeObjectsSearchNode
Versione 1.2.0 - 30 Aprile 2025 - Mauro Brasile
                 - CHG: Aggiunta OnSuccess alla funzione SearchNode()
Versione 1.1.0 - 31 Ottobre 2022 - Massimiliano  Zirilli
                 - NEW: Aggiunta OnSuccess alla funzione Select()
Versione 1.0.0 - 06 Agosto 2022 - Massimiliano  Zirilli
                 - Prima versione
*/

export class TZTree 
{
 constructor() 
 {
    this.Children = [];
    this.PreviousSelected = null;
    this.SelectableLevels = [];
    this.HideExpandedNodeOnExpanding = false;
 }

 AddChild(Caption, Data) 
 {
    var Result = new TZTreeItem(Caption, Data);
    Result.Parent = this;
    this.Children.push(Result);
    return Result;
 }

 Clear() 
 {
  this.Children = [];
  this.PreviousSelected = null;
  if(this.OnSelect != undefined)
     this.OnSelect(undefined); 
 }

 GetSelected()
 {
   return this.PreviousSelected;
 }

 Select(AnItem,OnSuccess) 
 {
  var DoOnSuccess = true
  if (this.SelectableLevels.length == 0 ||
      this.SelectableLevels.find(function (ALevel) { return (AnItem.Level == ALevel) }) != undefined) 
      if(AnItem != this.PreviousSelected)
      {
         DoOnSuccess = false
         AnItem.Selected = true;
         if(this.OnSelect != undefined)
            this.OnSelect(AnItem,OnSuccess); 
         if (this.PreviousSelected != null)
             this.PreviousSelected.Selected = false;
         this.PreviousSelected = AnItem;
      }
   if(DoOnSuccess && OnSuccess != undefined)
      OnSuccess();
      
 }

 DeleteNode(Node)
 {
   var Self = this;
   var Recursive = function(Children)
   { 
      let i = Children.indexOf(Node);
      if (i == -1) 
      {
         for(i = 0; i < Children.length; i++)
            if(Recursive(Children[i].Children))
               return true;
         return false;
      }
      else 
      {
         if(Self.BeforeDelete)
            Self.BeforeDelete(Node);
         Children.splice(i, 1); 
         return true;
      }
   }
   if(Recursive(this.Children))
     if(this.PreviousSelected == Node)
     {
       this.PreviousSelected = null;
       if(this.OnSelect != undefined)
          this.OnSelect(undefined); 
     }
 }

 SearchNode(Position,OnNodeNotFound, OnSuccess)
 {
    var Self = this;
    var SearchOnChildren = function(Children,Index)
    {
       var Node = Children.find(function(ANode)
       {
          return ANode.Data.Chiave == Position[Index];
       });
       if(Node != undefined)
       {
          if(Index == Position.length - 1)
            Self.Select(Node, OnSuccess)
          else
          {
            if(Node.Expanded)
               SearchOnChildren(Node.Children,Index + 1)            
            else
            {
              Self.ExpandToggle(Node,function()
              {
                SearchOnChildren(Node.Children,Index + 1)
              })
            }
          }
       }
       else 
       {
         if(OnNodeNotFound != undefined)
            OnNodeNotFound();
         if(OnSuccess != undefined)
            OnSuccess();
       }

    }
    if(Position.length != 0) 
       SearchOnChildren(this.Children,0);
 }

 ExpandToggle(AnItem,OnSuccess) 
 {
    var Self = this; 
    var DoToggle = function () 
    {
      AnItem.Expanded = !AnItem.Expanded;
      if (AnItem.Children.length > 0 &&
          AnItem.Expanded &&
          Self.HideExpandedNodeOnExpanding) 
         {
           AnItem.Parent.Children.forEach(function (Menu) 
           {
              if (Menu != AnItem) 
                 Menu.Expanded = false;
           });
         }
      AnItem.HasChildren = false;
      if(OnSuccess != undefined)
         OnSuccess();
    }

    if (AnItem.HasChildren && !AnItem.Expanded && AnItem.Children.length == 0 &&
        (typeof AnItem.Data === "object") && 
        AnItem.Data.BeforeExpand != undefined)
        AnItem.Data.BeforeExpand(AnItem, DoToggle);
    else DoToggle();
   }
}

export class TZTreeItem 
{
   constructor(Caption, Data, Level) 
   {
      this.Level = Level == undefined ? 1 : Level;
      this.Caption = Caption;
      this.Children = [];
      this.HasChildren = false;
      this.Data = Data;
      this.Selected = false;
      this.Expanded = false;
   }

   AddChild(Caption, Data) 
   {
      var Result = new TZTreeItem(Caption, Data, this.Level + 1);
      Result.Parent = this;
      this.Children.push(Result);
      return Result;
   }
}